module.exports = __webpack_public_path__ + "assets/water-meter-well.cf091570.svg";